import { getBrand } from '@shared/brand'
import React from 'react'
import { ActivityIndicator } from 'react-native-web'

const Spinner = props => {
    return <ActivityIndicator size={props.size} color={getBrand().navBarColor} {...props} />
}

export default Spinner
